<template>
  <nav class="navbar navbar-expand-lg navbar-light top-navbar">
    <div class="container-fluid">
      <img src="@/assets/img/logo-ministere.svg" class="logo" alt="Ministère de la Transition Écologique, de la Biodiversité et des Négociations Internationales sur le Climat et la Nature" />
      <div
        style="margin: 15px;font-size: 35px;font-family: 'Muli', 'Helvetica', Arial, sans-serif"
      >
        <a href="/index.html"
          ><span style="font-weight: bold;color: black">oreol</span>.developpement-durable.gouv.fr</a
        >
      </div>
      <button
        class="navbar-toggler navbar-burger"
        :class="{
          'sidebar--open': $sidebar.showSidebar
        }"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-auto" v-if="isUser">
          <li class="nav-item" @click="emitGlobalReloadParcs()">
            <router-link
              :to="homePageRouteObject"
              class="nav-link nav-link__parc"
              title="Consulter la liste des parcs"
            >
              <i class="ti-view-list"></i>
              <p id="menu-parcs">Mes parcs</p>
            </router-link>
          </li>

          <drop-down
            class="nav-item"
            :title="user.name"
            title-classes="nav-link"
            icon="ti-user"
          >
            <router-link
              to="profile-choice"
              class="nav-link nav-link__parc"
              title="Changer de profil"
              v-if="showChangeProfileBtn"
            >
              <i class="ti-tag"></i>
              <p>Changer de profil</p>
            </router-link>

            <a
              :href="logoutUrl"
              class="nav-link nav-link__parc"
              title="Quitter l'application"
            >
              <i class="ti-shift-right "></i>
              <p>Quitter</p>
            </a>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
import { env } from "../../env";

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters({
      user: "user",
      isUser: "isUser",
      homePageRouteObject: "homePageRouteObject",
      oreolDroitsCount: "oreolDroitsCount"
    }),
    showChangeProfileBtn() {
      return this.oreolDroitsCount > 1;
    }
  },
  data() {
    return {
      activeNotifications: false,
      logoutUrl: env.logoutUrl
    };
  },
  created() {
    this.init();
    this.oreolDroitsCount;
  },
  methods: {
    init() {},
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    emitGlobalReloadParcs() {
      this.$store.dispatch("reloadParcsAndSearchParams");
    }
  }
};
</script>
<style lang="scss">
.top-navbar {
  .logo {
    padding: 3px 0;
  }

  .nav-link {
    i {
      top: 2px !important;
    }

    &__parc {
      i {
        right: 8px !important;
      }
    }

    &__logout {
      i {
        right: 3px !important;
      }
    }
  }

  .navbar-burger {
    position: absolute;
    top: -10px;
    right: 5px;
  }

  .sidebar--open.navbar-burger {
    transform: rotate(90deg);
  }
}
</style>
